<mat-form-field [floatLabel]="floatLabel" #chipsWrapper
                (click)="clickInput(input, chipsWrapper)"
                class="related-document-chips-wrapper mat-chips-is-not-focused" [ngClass]="(selected.length>0) ? 'has-content' : ''" >
  <mat-label
      class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ft-label"
      [title]="componentDefinition?.label"
      [style]="labelStyle">{{componentDefinition?.label}}</mat-label>
  <mat-chip-list #relatedDocList aria-label="{{componentDefinition?.label}}" [disabled]="disabled">
    <mat-chip *ngFor="let item of selected" class="related-document-chips text-ellipsis" color="primary" [disabled]="disabled" [selectable]="selectable" [removable]="removable"
      (removed)="onRemove(item)">
      <a *ngIf="!disableLink" (click)="relatedDocumentService.openLink(item, $event, componentDefinition)" class="mat-chip-link" [title]="item.name"
        [href]="'/form/' + item.documentId">{{item.name}}</a>
      <span *ngIf="disableLink"  class="mat-chip-disable-link">
        {{item.name}}
      </span>
      <button matChipRemove *ngIf="removable && (!disabled)" (click)="removeChip(item)">
        <mat-icon>close</mat-icon>
      </button>
    </mat-chip>
    <input autocompleteInput [disabled]="disabled" [placeholder]="selected.length ? '' : componentDefinition?.label" #input [formControl]="inputCtrl"  (blur)="inputBlur(input, chipsWrapper)"
           [matAutocomplete]="auto" [matChipInputFor]="relatedDocList" (focus)="focusInEvent()"
           (focusout)="focusOutEvent()" />
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelect($event)">
    <mat-option *ngFor="let result of searchResults | async" [value]="result" title="{{result.name}}">
      {{result.name}}
    </mat-option>

    <div
      *ngIf="totalItems > options.pageSize && totalItems !== options.pageSize"
      (click)="loadMore()" style="display: flex;align-items: center;justify-content: center;padding:4px;cursor:pointer;color:#3f51b5;">
      <small>
        <span class="loading-text" style="display:block;text-align: center;">({{options.pageSize}} / {{totalItems}})<br />Load More</span>
      </small>
    </div>
  </mat-autocomplete>
  <button matSuffix *ngIf="!disabled"  type="button" class="mat-button hidden-print x-close" [disabled]="disabled" title="Clear All">
    <mat-icon (click)="clear()">close</mat-icon>
  </button>
  <button matSuffix type="button" [disabled]="disabled" class="mat-button hidden-print drop-down-arrow" title="">
    <i class="material-icons" (click)="clickInput(input,chipsWrapper)" >arrow_drop_down</i>
  </button>
  <button matSuffix type="button" mat-button class="mat-button hidden-print" title="Add {{componentDefinition?.label}}"
    *ngIf="componentDefinition?.newTemplate" [disabled]="disabled" (click)="relatedDocumentService.showTemplateDialog(componentDefinition)">
    <i class="material-icons">library_add</i>
  </button>
</mat-form-field>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
